export default __webpack_public_path__ + "static/media/shivangi.3b1cbe9c.jpg";